import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from '../constants/dictionary.constant';

export const tabOptions = (data) => {
	return [
		{
			key: 'pending',
			tab: Dictionary[Enviroment.LANGUAGE].pending,
			data: data,
			status: 100,
		},
		{
			key: 'sended',
			tab: Dictionary[Enviroment.LANGUAGE].sended,
			data: data,
			status: 400,
		},
		{
			key: 'paid',
			tab: Dictionary[Enviroment.LANGUAGE].paid,
			data: data,
			status: 600,
		},
		{
			key: 'cancelled',
			tab: Dictionary[Enviroment.LANGUAGE].cancelled,
			data: data,
			status: 500,
		}
	];
};
